import React from 'react'
import PropTypes from 'prop-types'

import UserIcon from "../../../../../gd-components/icons/user/user"

// extends React.Component is required because of reference in parent
export default class FieldAssignees_PopoverOption extends React.Component<any> {

    static propTypes = {
        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        if (this.props.isSelected) return null

        const classes = Classes('option pill', {
            'highlighted': this.props.isHighlighted
        })

        return (
            <div className={classes} onClick={this.onClick}>
                {this.props.option.value &&
                    <UserIcon className="fl-no-shrink m-r-8" userId={this.props.option.value} size="22"/>}
                <div className="ui5-txt-default">{this.props.option.label}</div>
            </div>
        )
    }
}